"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextAreaContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactUseControlledState = _interopRequireDefault(require("@quid/react-use-controlled-state"));
var _TextArea = require("../TextArea");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TextAreaContainer = _ref => {
  let {
    defaultValue,
    value,
    onChange,
    onBlur,
    onFocus,
    textareaId,
    ...originalProps
  } = _ref;
  const [stateValue, setStateValue] = (0, _reactUseControlledState.default)(defaultValue, value, onChange);
  const [hasFocus, setHasFocus] = (0, _react.useState)(false);
  const autoGrowWrapperRef = (0, _react.useRef)(null);
  const handleInput = e => {
    if (autoGrowWrapperRef?.current) {
      autoGrowWrapperRef.current.dataset.replicatedValue = e.currentTarget.value;
    }
  };
  const handleChange = e => {
    setStateValue(e.currentTarget.value);
  };
  const handleFocus = e => {
    setHasFocus(true);
    onFocus && onFocus(e.currentTarget.value);
  };
  const handleBlur = e => {
    setHasFocus(false);
    onBlur && onBlur(e.currentTarget.value);
  };
  return /*#__PURE__*/_react.default.createElement(_TextArea.TextArea, (0, _extends2.default)({}, originalProps, {
    textareaId: textareaId,
    autoGrowWrapperRef: autoGrowWrapperRef,
    hasFocus: hasFocus,
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus,
    onInput: handleInput,
    value: stateValue
  }));
};
exports.TextAreaContainer = TextAreaContainer;
//# sourceMappingURL=TextAreaContainer.js.map